export default __webpack_public_path__ + "static/media/4670.aab79f4d.png";